import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-caja-form",
  templateUrl: "./form.component.html",
})
export class CajaFormComponent implements OnInit {
  public form: FormGroup;
  public defaults?: any = undefined;
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CajaFormComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public ngOnInit() {
    this.buildForm();
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      EoS: [""],
      Cantidad: [""],
      Razon: [""],
    });
  }

  save() {
    const data = this.form.value;
    this.dialogRef.close({
      ...data,
      IdTrabajador: this.data.IdTrabajador,
    });
  }
}
